import React from 'react';
import styles from '../TabShared.module.css';

interface TabCardHeaderProps {
    icon?: React.ReactNode;
    title: React.ReactNode;
    actions?: React.ReactNode;
    draggable?: boolean;
    onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
}

/**
 * Shared card header with standardized layout (icon + title + actions).
 * Styling is centralized in TabShared.module.css.
 */
export const TabCardHeader: React.FC<TabCardHeaderProps> = ({icon, title, actions, draggable, onDragStart}) => {
    return (
        <div className={styles.cardHeaderPrimaryInner} draggable={draggable} onDragStart={onDragStart}>
            <span className={styles.cardHeaderTitleWrap}>
                {icon && <span className={styles.cardHeaderIcon}>{icon}</span>}
                <span className={styles.cardHeaderTitle}>{title}</span>
            </span>
            {actions && <div>{actions}</div>}
        </div>
    );
};
